export default {
    /**
     * Do a stable array sort.
     * Most browsers sorts are stable by default. However, there is no guarantee.
     * This does NOT modify the passed in array.
     * @param array
     * @param compare
     */
    stableSort: function(array, compare) {
        return array
            .map(function(item, i) {
                return {
                    position: i,
                    item: item
                };
            })
            .sort(function(c1, c2) {
                var compared = compare(c1.item, c2.item);
                if (compared === 0 || isNaN(compared)) {
                    return c1.position - c2.position;
                } else {
                    return compared;
                }
            })
            .map(function(c) {
                return c.item;
            });
    }
}
